import React, { useState, useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import CenteredSpinner from './CenteredSpinner';
import fire from '../images/fire.svg';
import ScrollToTop from 'react-scroll-to-top';
import { useQuery } from 'react-query';
import { PropertyCard } from './PropertyCard';

export const HotProperties = () => {
  const [search, setSearch] = useState('');
  const location = useLocation();
  const [forSaleOrToLet, setForSaleOrToLet] = useState(null);
  //forSaleOrToLet Reference
  const saleOrLet = useRef();
  saleOrLet.current = forSaleOrToLet;
  const navigate = useNavigate();

  useEffect(() => {
    let token = localStorage.getItem('token');
    axios.defaults.headers.common[
      'Authorization'
    ] = `Bearer ${token}`;

    document.title = 'Hot Properties';
    window.scrollTo(0, 0);
    refetch();
  }, [forSaleOrToLet]);

  const fetchHotProperties = () => {
    let filterSaleOrLet = null;
    if (forSaleOrToLet != null) {
      forSaleOrToLet === "true" ? filterSaleOrLet = true : filterSaleOrLet = false;
    }

    const options = {
      method: 'POST',
      url: '/property/gethotproperties',
      headers: {
        Accept: 'application/json',
      },
      data: {
        includeImgs: true,
        forSaleOrToLet: saleOrLet.current
      },
    };

    return axios
      .request(options)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        throw new Error('Server error');
      });
  };

  const {
    isLoading,
    isError,
    data: HotPropertiesData,
    refetch
  } = useQuery(['HotProperties'], fetchHotProperties, {
    refetchOnWindowFocus: false,
    enabled: false // turned off by default, manual refetch is needed
  });

  const handleForSaleOrToLetChange = (event) => {
    event.preventDefault();
    event.persist();
    if (forSaleOrToLet == event.target.dataset.forsaleortolet) {
      setForSaleOrToLet(null);
      return;
    }
    setForSaleOrToLet(event.target.dataset.forsaleortolet);
  };

  const filterHotProperties = (HotProperties, search) => {
    if (!search) {
      return HotProperties;
    }

    return HotProperties.filter((hotProperty) => {
      return (
        hotProperty?.propertyTypeName
          .replace(/,/g, '')
          .toLowerCase()
          .includes(search.replace(/,/g, '').toLowerCase()) ||
        hotProperty?.localityName
          .replace(/,/g, '')
          .toLowerCase()
          .includes(search.replace(/,/g, '').toLowerCase()) ||
        hotProperty?.propertyStateName
          .replace(/,/g, '')
          .toLowerCase()
          .includes(search.replace(/,/g, '').toLowerCase()) ||
        hotProperty?.propertyRef.includes(search)
      );
    });
  };

  const filterHotProperty = filterHotProperties(
    HotPropertiesData,
    search,
  );

  const totalHot = filterHotProperty?.length ?? 0;

  if (isLoading) {
    return <CenteredSpinner />;
  }

  if (isError) {
    return (
      <div className="container">
        <div className="row justify-content-center align-items-center vh-100">
          <h1>Server is down, please try again later </h1>
        </div>
      </div>
    );
  }

  return (
    <div className="container pt-3 pb-4">
      <ScrollToTop smooth color="#6f00ff" />
      <div className="card shadow-sm border-0 overflow-hidden property-list-card">
        <div className="property-list-hero d-flex align-items-center px-4 py-3">
          <div className="property-list-hero-icon d-flex align-items-center justify-content-center">
            <img className="property-list-hero-icon-img" src={fire} alt="Hot" />
          </div>
          <div className="ml-3">
            <p className="mb-1 text-uppercase text-white-50 small">Hot Properties</p>
            <h4 className="mb-0 text-white">High-priority listings.</h4>
          </div>
          <button
            type="button"
            className="btn btn-light btn-sm ml-auto property-list-back"
            onClick={() => navigate(-1)}
          >
            <i className="fas fa-arrow-left me-2"></i>
            Back
          </button>
        </div>

        <div className="p-4">
          <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between">
            <div className="d-flex align-items-center">
              <div className="property-list-count">{totalHot}</div>
              <div className="ml-3">
                <p className="mb-1 text-muted small">Listed properties</p>
                <h5 className="mb-0">You are viewing hot listings.</h5>
              </div>
            </div>
          </div>

          <div className="row mt-3">
            <div className="col-12 col-md-7 mb-3">
              <div className="form-group has-search w-100 property-list-search">
                <span className="fa fa-search form-control-feedback"></span>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
              </div>
            </div>
            <div className="col-12 col-md-5 mb-3">
              <div className="d-flex justify-content-center align-items-center property-filter-group">
                <button
                  type="button"
                  className={`property-filter-pill ${forSaleOrToLet === 'false' ? 'property-filter-pill--active' : ''}`}
                  onClick={handleForSaleOrToLetChange}
                  data-forsaleortolet="false"
                >
                  For Sale
                </button>
                <button
                  type="button"
                  className={`property-filter-pill ${forSaleOrToLet === 'true' ? 'property-filter-pill--active' : ''}`}
                  onClick={handleForSaleOrToLetChange}
                  data-forsaleortolet="true"
                >
                  To Let
                </button>
              </div>
            </div>
          </div>

          {totalHot < 1 ? (
            <h5 className="text-center text-muted">No search results found</h5>
          ) : null}

          <div className="row mb-4">
            {filterHotProperty &&
              React.Children.toArray(
                filterHotProperty?.map((property, index) => (
                  <PropertyCard
                    property={property}
                    index={index}
                    location={location}
                  />
                )),
              )}
          </div>
        </div>
      </div>
    </div>
  );
};
